import $ from 'jquery';

$(window).on("load", function (e) {
  if ($(window).outerWidth() < 768) {
    const accor1 = $('.js-accor1');

    $('.js-accor1-content').hide();

    accor1.each(function () {

      const accor1Btn = $(this).find('.js-accor1-btn');
      const accor1Content = $(this).find('.js-accor1-content');

      $('.is-close').hide();

      accor1Btn.on('click', function () {
        $(this).toggleClass('is-active');
        accor1Content.toggleClass('is-active');
        accor1Content.slideToggle();

        if ($(this).hasClass('is-active')) {
          $(this).find('.is-open').hide();
          $(this).find('.is-close').show();
        } else {
          $(this).find('.is-open').show();
          $(this).find('.is-close').hide();
        }
      });
    });
  } else {}
});


$('.js-accor2').on('click', 'a', function (e) {
  e.preventDefault();
  let tabId = $(this).attr('data-tab');
  $(this).closest('.js-accor2').find('a').removeClass('is-current');
  $(this).addClass('is-current');
  $('.c-tabs1__content').removeClass('is-current');
  $('#' + tabId).addClass('is-current');
});


let clist5__detail = $(".js-list5-detail");
clist5__detail.hide();

$(".js-list5-inner1").on("click", function () {
  $(this).toggleClass("is-open");
  $(this).next().slideToggle()
});
